import { ESortOption } from './types';
import { Product } from '@/_models/eCommerce/Product';
import { checkIsFavourite } from '@/_helpers/base';

export const DEFAULT_SORT = 'price';
export const DEFAULT_LIMIT = 12;

const unnecesaryKeysForRequest = ['liked', 'err', 'sort', 'discount'];

export const UniversalOptionAll = 'Any';
export const initialFilters: any = {
  search: '',
  mobileSearch: '',
  minPrice: '',
  maxPrice: '',
  liked: false,
  discount: false,
  brandId: UniversalOptionAll,
  color: UniversalOptionAll,
  productTypeId: UniversalOptionAll,
  sort: ESortOption.priceDesc,
  err: {},
};

const isConditionExist = (key, value) => !unnecesaryKeysForRequest.includes(key) && value !== UniversalOptionAll && value !== '';

export const validateData = (data: any) => {
  return Object.entries(data).reduce((acc, cur) => {
    const [key, value] = cur;
    if (isConditionExist(key, value)) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

export const transformDataForRequest = (data: any) => {
  const actualData = validateData(data);
  return {
    search: data.search || data.mobileSearch,
    discount: data.discount || undefined,
    ...actualData,
  };
};

export const filterCbMain = (data: any, favouriteProducts: any) => (product: Product) => {
  let isViable = true;
  if (data['liked']) {
    isViable = isViable && checkIsFavourite(favouriteProducts, product);
  }
  if (data['discount']) {
    isViable = isViable && !!product.comparePrice;
  }
  if (data['minPrice'] && !isNaN(Number(data['minPrice']))) {
    isViable = isViable && product.price >= Number(data['minPrice']);
  }
  if (data['maxPrice'] && !isNaN(Number(data['maxPrice']))) {
    isViable = isViable && product.price <= Number(data['maxPrice']);
  }
  if (data['brand'] !== UniversalOptionAll) {
    isViable = isViable && product.eCommerceVendorId === data['brand'];
  }
  if (data['color'] !== UniversalOptionAll) {
    isViable = isViable && product?.variants?.find((v) => v?.colorOption?.value === data['color']);
  }
  if (data['productType'] !== UniversalOptionAll) {
    isViable = isViable && product.eCommerceProductTypeId === data['productType'];
  }
  if (data['search'] !== UniversalOptionAll) {
    isViable = isViable && product?.title?.toLowerCase()?.includes(data['search']?.toLowerCase());
  }
  return isViable;
};
export const getSortOptions = (translation: Record<string, string>) => [
  {
    label: translation.priceDesc || 'Price Desc.',
    value: ESortOption.priceDesc,
  },
  {
    label: translation.priceAsc || 'Price Asc.',
    value: ESortOption.priceAsc,
  },
];

export const getBrandOptions = (translation, filterOptions: any) => [
  {
    label: translation.optionAny || UniversalOptionAll,
    value: UniversalOptionAll,
  },
  ...filterOptions?.vendors?.map((v) => ({ label: v.name, value: v.id })),
];
export const getColorOptions = (translation, filterOptions: any) => [
  {
    label: translation.optionAny || UniversalOptionAll,
    value: UniversalOptionAll,
  },
  ...filterOptions?.options?.map((o) => ({ label: o?.label || o?.value, value: o?.value })),
];
export const getProductTypeOptions = (translation, productTypes: any) => [
  {
    label: translation.optionAny || UniversalOptionAll,
    value: UniversalOptionAll,
  },
  ...(productTypes?.map((pt) => ({ label: pt?.name, value: pt?.id })) || []),
];
